import { SquareSlashIcon } from "lucide-react";
import { type ComponentPropsWithRef, useState } from "react";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";
import { cn } from "@/lib/utils";
import { useDebounce } from "@/ui/hooks/use-debounced-value";
import type { Input } from "./shadcn/input";
import { Popover, PopoverContent, PopoverTrigger } from "./shadcn/popover";

export const StatefulColorPicker = ({
	// value,
	// onChange,
	defaultValue,
	onValueChange,
	// ...props
}: Omit<ComponentPropsWithRef<typeof Input>, "defaultValue"> & {
	onValueChange?: (value: string | null) => void;
	defaultValue?: string | null;
}) => {
	const [color, setColor] = useState(defaultValue);
	// TODO move the empty function inside the useDebounce
	const onColorChange = useDebounce(onValueChange ?? (() => {}), 200);

	return (
		<div className="flex gap-2 items-center">
			<Popover>
				<PopoverTrigger asChild>
					<button
						type="button"
						className={cn(
							"w-6 h-6 aspect-square rounded ring-1 ring-offset-1 ring-neutral-500/25 transition-shadow",
							"focus:outline-hidden focus:ring-blue-500",
							"hover:ring-blue-500",
						)}
						style={{ backgroundColor: color ?? undefined }}
						aria-label={`Select color ${color}`}
					>
						{color ? "" : <SquareSlashIcon className="size-4 mx-auto text-muted-foreground/30" />}
					</button>
				</PopoverTrigger>
				<PopoverContent className="w-auto p-0" align="start">
					<HexAlphaColorPicker
						// override default color to make sure opacity is set to 100%
						color={color ?? "#23d2f1ff"}
						onChange={(color) => {
							setColor(color);
							onColorChange?.(color);
						}}
					/>
				</PopoverContent>
			</Popover>
			<HexColorInput
				color={color ?? undefined}
				onBlur={(e) => {
					if (!e.currentTarget.value || e.currentTarget.value === "#") {
						setColor(null);
						onColorChange?.(null);
					}
				}}
				onChange={(color) => {
					setColor(color);
					onColorChange?.(color);
				}}
				alpha={true}
				prefixed={true}
				className="bg-white border rounded px-2 h-6 w-[9ch] box-content font-mono"
			/>
		</div>
	);
};
